var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "dubl_currinces mb-5" }, [
      _c(
        "div",
        {},
        [
          _c("yes_no", {
            key: "SHOW_DOUBLE_CURRENCY",
            attrs: { title: "SHOW_DOUBLE_CURRENCY" },
            model: {
              value: _vm.show_double_currency,
              callback: function ($$v) {
                _vm.show_double_currency = $$v
              },
              expression: "show_double_currency",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "form-group mt-2" }, [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "wcssurrency" } },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.__t("WOLT_CURRENCIES")) +
                "*\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.currencies.length > 0
          ? _c(
              "div",
              {},
              [
                _c(
                  "v-select",
                  {
                    key: "w_curency",
                    staticClass: "imc_reasons",
                    attrs: {
                      label: "name",
                      options: this.currencies,
                      filterable: false,
                      clearable: false,
                    },
                    model: {
                      value: _vm.active_currency,
                      callback: function ($$v) {
                        _vm.active_currency = $$v
                      },
                      expression: "active_currency",
                    },
                  },
                  [
                    _c("template", { slot: "no-options" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.__t("CHOICE_CURENCY")) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-2" }, [
        _c(
          "label",
          {
            staticClass: "form-label",
            attrs: { for: "pwa.default_geo_radius" },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.__t("pwa.cross_currency")) +
                "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-group flex-nowrap" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("b-form-input", {
              staticClass: "form-control",
              attrs: { id: "pwa.default_geo_radius" },
              model: {
                value: _vm.pwa.double_currency.cross_currency,
                callback: function ($$v) {
                  _vm.$set(_vm.pwa.double_currency, "cross_currency", $$v)
                },
                expression: "pwa.double_currency.cross_currency",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }